import { getEkeyUserData } from "./request.get-user-identity.e-key.js";
import { getUnicUserData } from "./request.get-user-identity.unic.js";
//#region src/request.get-user-identity.ts
/**
* fetch data for the user based on the given loginProvider, automatically
* converting it to our internal data definition.
*/
async function getUserIdentityRequest(userId, loginProvider) {
	switch (loginProvider) {
		case "UNIC": return getUnicUserData(userId);
		case "EKEY": return getEkeyUserData(userId);
		default: return {
			id: userId,
			name: userId,
			role: "teacher",
			authenticationProvider: "ip"
		};
	}
}
//#endregion
export { getUserIdentityRequest };

//# sourceMappingURL=request.get-user-identity.js.map